import request from '@/utils/request'
export function imageCaptcha(){
  return request({
    url: '/api/oauth/captcha/image',
    method: 'get'
  })
}
export function oauthLogin(data: any) {
  return request({
    url: '/api/oauth/login',
    method: 'post',
    data
  })
}
export function designLoginVerification(data: Record<string, any>) {
  return request({
    url: '/api/design_login_verification',
    method: 'post',
    data,
    baseURL: 'https://www.aishanyin.com'
  })
}